function FormNavigation({ currentStep, onBack, onNext, showSubmit, onSubmit }) {
  return (
    <div className="navigation-row">
      {currentStep > 1 ? (
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Atrás
        </button>
      ) : (
        <div />
      )}

      {showSubmit ? (
        <button type="button" className="btn btn-primary" onClick={onSubmit}>
          Enviar
        </button>
      ) : (
        <button
          type="button"
          className={`btn btn-primary ${currentStep === 1 ? 'btn-full' : ''}`}
          onClick={onNext}
        >
          Siguiente
        </button>
      )}
    </div>
  );
}

export default FormNavigation;